import { overridePriceBucket } from '../price-config';
export const bidderSettings = {
    adserverTargeting: [
        {
            key: 'hb_pb',
            val: ({ width, height, cpm, pbCg }) => {
                return overridePriceBucket('ozone', width, height, cpm, pbCg);
            },
        },
    ],
};
